import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export function useTrocaTitularidadeTab(): string {
  const { search } = useLocation();

  return useMemo(() => {
    const { tab } = queryString.parse(search);
    return `${tab}` || "1";
  }, [search]);
}
